import { Alert, Chip, CircularProgress } from '@mui/material'
import ErrorFallback from 'components/ErrorFallback'
import { usePharmacyTreatmentDetails, usePharmacyTreatmentNote } from 'data/treatments'
import { isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'
import { formatDate, formatTime } from 'utils'

const chipColor = {
  completed: 'success',
  ongoing: 'info',
  cancelled: 'error',
  pending: 'primary',
} as const

export default function PharmacyTreatmentDetails() {
  const { treatmentId } = useParams()
  const { data, isLoading, isError, refetch } = usePharmacyTreatmentDetails(treatmentId as string)
  const { data: notes, isError: isErrorNote } = usePharmacyTreatmentNote(treatmentId as string)

  return (
    <div>
      {isLoading ? (
        <div className="grid place-items-center mt-40 overflow-hidden">
          <CircularProgress />
        </div>
      ) : isError ? (
        <div>
          <ErrorFallback
            message="Something went wrong"
            description="We could not fetch treatment"
            reset={refetch}
            buttonText="Try again"
          />
        </div>
      ) : (
        <div className="lg:w-[39rem] mx-auto">
          <div
            key={data.id}
            className="rounded-xl p-5 border border-default font-medium space-y-4 mt-6  "
          >
            <p>
              <span className="font-semibold">Start Date</span>
              {' : '}
              {formatDate(data?.treatment_start_date)}{' '}
            </p>

            <p>
              <span className="font-semibold">Time</span>
              {' : '}
              {formatTime(data?.created_at)}{' '}
            </p>

            <p>
              <span className="font-semibold">Pharmacist:</span> {' : '} {data.metadata?.staff_name}
            </p>

            <p>
              <span className="font-semibold">Diagnosis</span> {' : '} {data?.diagnosis}{' '}
            </p>

            <p>
              {' '}
              <span className="font-semibold">Treatment</span> {' : '} {data?.treatment_name}{' '}
            </p>

            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <p className="font-semibold">Status </p>
                {' : '}
                <Chip
                  color={chipColor[data.treatment_status]}
                  label={data?.treatment_status}
                  className={`ml-2`}
                />
              </div>
              {/* <button
                        className="rounded-xl text-brand-700"
                        onClick={() => navigate(item.id)}
                      >
                        View Details
                      </button> */}
            </div>

            <div className="grid gap-4">
              <p className="font-semibold">Treatment Note</p>

              <div className="border border-brand-200 rounded-xl px-6 py-[21px]">{data.note}</div>
            </div>
            {isErrorNote && (
              <p className="text-red-500">
                <Alert
                  severity={'error'}
                  className={`mt-4 ${!isErrorNote ? 'opacity-0' : ''}`}
                  aria-hidden={!isErrorNote}
                >
                  We could not fetch pharmacist's note
                </Alert>
              </p>
            )}
            {!isEmpty(notes) && (
              <div className="grid gap-4">
                <p className="font-semibold">Pharmacist's Note</p>
                {notes?.map((note) => (
                  <div key={note.id} className="border border-brand-200 rounded-xl px-6 py-[21px]">
                    <div dangerouslySetInnerHTML={{ __html: note.content }} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}